import React, {Component} from 'react'
import ReactTable from 'react-table'
import {Query, SubscriptionWrapper} from 'react-apollo'
import {debounce} from 'lodash'
import {withRouter} from "react-router-dom"
import 'react-table/react-table.css'

import AUSelectGenerator from '../auto_updaters/Select'

import QUERY from '../../../queries/server/filter_clients'
//import SUBSCRIPTION from '../../../queries/server/subscriptions/project_upserted'

const AUSelectClientTypes = AUSelectGenerator('client_types', 'client_type_id description', 'client_type_id', ['description'])


class ClientsList extends Component {

    componentDidMount() {
        this.props.subscribeToUpsert()
    }

    render() {
        return (<ReactTable
            data={this.props.projects}
            loading={this.props.loading}
            style={{display: 'flex', flex: 1, fontSize: '14px'}}
            columns={[
                {
                    Header: "Name",
                    id: 'name',
                    accessor: 'name'
                },
                {
                    Header: "Client Type",
                    id: 'client_type_id',
                    accessor: "client_type.description",
                    Filter: ({filter, onChange}) => {
                        return <AUSelectClientTypes className="form-control-sm" value={(filter) ? filter.value : null} onChange={onChange}/>
                    }
                }
            ]}
            className="-striped -highlight"
            onFetchData={debounce((state, instance) => this.props.onFetchData(state, instance), 500, {
                leading: true,
                trailing: false
            })} // Request new data when things change
            filterable
            manual
            showPagination={true}
            pages={this.props.pages}
            getTrProps={(state, rowInfo) => {
                return {
                    onClick: (e) => {
                        console.log(rowInfo)
                        this.props.history.push(`/clients/${rowInfo.original.client_id}`)
                        //Router.push({pathname: '/projects/edit', query: { project_id: rowInfo.original.project_id }})
                    }
                }
            }}
        />)
    }
}

ClientsList = withRouter(ClientsList)

export default class ClientsTable extends Component {

    state = {
        name: '',
        client_type_id: null,
        limit: 10,
        offset: 0
    }

    fetchData = (state, instance) => {

        console.log('filter', state.pageSize, state.page)

        let filters = state.columns.reduce((carry, column) => {
            if (column.hasOwnProperty('id')) {
                const filterValue = state.filtered.find(({id}) => id === column.id)
                carry[column.id] = (filterValue) ? filterValue.value : ''
            }
            return carry
        }, {})

        this.setState(Object.assign({}, filters, {limit: state.pageSize, offset: state.pageSize * state.page}))
    }

    render() {

        const {name, client_type_id, limit, offset} = this.state
        return (<Query query={QUERY} fetchPolicy="no-cache" variables={{
            name,
            client_type_id,
            limit,
            offset
        }}>
            {(result) => {

                console.log('clients', result)

                const clients = (result.data && result.data.filter_clients) ? result.data.filter_clients : []

                return (
                    <ClientsList
                        loading={result.loading}
                        projects={clients}
                        pages={Math.ceil(result.data.filter_clients_total / limit)}
                        onFetchData={this.fetchData}
                        subscribeToUpsert={() => {
                            /*return result.subscribeToMore(
                                {
                                    document: SUBSCRIPTION,
                                    variables: {
                                        name,
                                        client_type_id,
                                    },
                                    updateQuery: (prev, {subscriptionData}) => {

                                        if (!subscriptionData.data) {
                                            return prev
                                        }

                                        let data = {}

                                        //does the record already exist using the uniqueKey
                                        const existingRecordIndex = prev.filter_clients.findIndex(data => data.client_id === subscriptionData.data.clientsUpserted.client_id)

                                        if (existingRecordIndex !== -1) {
                                            data['filter_clients'] = [
                                                ...prev.filter_clients.slice(0, existingRecordIndex),
                                                {...subscriptionData.data.clientsUpserted},
                                                ...prev.filter_clients.slice(existingRecordIndex + 1)
                                            ]
                                        }
                                        else {
                                            data['filter_clients'] = [...prev.filter_clients, subscriptionData.data.clientsUpserted]
                                        }


                                        return data
                                    }
                                }
                            )*/
                        }}/>

                )
            }}
        </Query>)
    }

}